import { render } from "./PageHero.vue?vue&type=template&id=79603574&scoped=true"
import script from "./PageHero.vue?vue&type=script&lang=js"
export * from "./PageHero.vue?vue&type=script&lang=js"

import "./PageHero.vue?vue&type=style&index=0&id=79603574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79603574"]])

export default __exports__